module.exports = __webpack_public_path__ + "../index.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/index.html
// module id = 224
// module chunks = 0